import React from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useTheme,
  Grid,
} from '@mui/material';
import {
  Gavel,
  Description,
  Security,
  Policy,
  Balance,
} from '@mui/icons-material';

const TermsOfService = () => {
  const theme = useTheme();

  const termsSections = [
    {
      icon: <Description sx={{ color: theme.palette.primary.main, fontSize: 40 }} />,
      title: 'Acceptance of Terms',
      content: [
        'By accessing and using our website, you agree to be bound by these terms and conditions',
        'These terms apply to all users, including visitors, registered users, and customers',
        'We reserve the right to modify these terms at any time without prior notice',
        'Continued use of the website constitutes acceptance of any changes',
        'Users are responsible for regularly reviewing the most current version of the terms'
      ]
    },
    {
      icon: <Gavel sx={{ color: theme.palette.primary.main, fontSize: 40 }} />,
      title: 'Use License',
      content: [
        'Permission granted to temporarily download materials for personal, non-commercial use',
        'No modification of website materials is permitted',
        'Prohibited from using materials for commercial purposes',
        'Reproduction or redistribution of content is not allowed without explicit permission',
        'Violation of these terms may result in immediate termination of access'
      ]
    },
    {
      icon: <Security sx={{ color: theme.palette.primary.main, fontSize: 40 }} />,
      title: 'User Responsibilities',
      content: [
        'Provide accurate and complete information during registration',
        'Maintain the confidentiality of account credentials',
        'Notify us immediately of any unauthorized account use',
        'Comply with all applicable laws and regulations',
        'Refrain from any conduct that may disrupt our services'
      ]
    },
    {
      icon: <Balance sx={{ color: theme.palette.primary.main, fontSize: 40 }} />,
      title: 'Limitation of Liability',
      content: [
        'WTT International is not liable for direct or indirect damages',
        'Services provided "as is" without warranties of any kind',
        'No guarantee of uninterrupted or error-free service',
        'Maximum liability limited to the amount paid for services',
        'Users agree to indemnify WTT International against any claims'
      ]
    }
  ];

  return (
    <Box sx={{ 
      bgcolor: '#f8f9fa', 
      minHeight: '100vh', 
      pt: 8, 
      pb: 12 
    }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
            variant="h2"
            component="h1"
            sx={{
              fontWeight: 700,
              color: theme.palette.primary.main,
              mb: 2,
              position: 'relative',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: -10,
                left: '50%',
                transform: 'translateX(-50%)',
                width: 100,
                height: 4,
                bgcolor: theme.palette.primary.main
              }
            }}
          >
            Terms of Service
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: theme.palette.text.secondary,
              maxWidth: 800,
              mx: 'auto',
              lineHeight: 1.6,
            }}
          >
            Please read these terms and conditions carefully before using our website and services.
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {termsSections.map((section, index) => (
            <Grid item xs={12} md={6} key={section.title}>
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  height: '100%',
                  borderRadius: 2,
                  bgcolor: 'white',
                  border: '1px solid',
                  borderColor: 'divider',
                  transition: 'transform 0.3s, box-shadow 0.3s',
                  '&:hover': {
                    transform: 'translateY(-10px)',
                    boxShadow: theme.shadows[4]
                  }
                }}
              >
                <Box sx={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  mb: 2 
                }}>
                  {section.icon}
                  <Typography 
                    variant="h5" 
                    sx={{ 
                      ml: 2, 
                      fontWeight: 600, 
                      color: theme.palette.primary.main 
                    }}
                  >
                    {section.title}
                  </Typography>
                </Box>
                <List>
                  {section.content.map((item, itemIndex) => (
                    <ListItem key={itemIndex} sx={{ px: 0, py: 0.5 }}>
                      <ListItemIcon sx={{ minWidth: 40 }}>
                        <Policy sx={{ color: theme.palette.primary.light }} />
                      </ListItemIcon>
                      <ListItemText 
                        primary={
                          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                            {item}
                          </Typography>
                        } 
                      />
                    </ListItem>
                  ))}
                </List>
              </Paper>
            </Grid>
          ))}
        </Grid>

        <Box sx={{ mt: 6, textAlign: 'center' }}>
          <Typography 
            variant="h5" 
            sx={{ 
              mb: 2, 
              fontWeight: 600, 
              color: theme.palette.primary.main 
            }}
          >
            Governing Law
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
            These terms and conditions are governed by the laws of India, 
            with exclusive jurisdiction in the courts of Tiruppur, Tamil Nadu.
          </Typography>
          <Typography 
            variant="h6" 
            sx={{ 
              color: theme.palette.primary.main, 
              fontWeight: 600,
              mt: 3
            }}
          >
            Contact Us
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
            For any questions regarding these Terms of Service, please contact:
          </Typography>
          <Typography 
            variant="h6" 
            sx={{ 
              color: theme.palette.primary.main, 
              fontWeight: 600 
            }}
          >
            legal@wttint.com
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', mt: 2 }}>
            Last Updated: January 2024
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default TermsOfService; 